__webpack_require__.p = "/CardManagerReact/";